import { loadable } from '@shared/core/loadableFromNamedExport';

/** Code-split entry for the Curtain motion type; loads only when Motion resolves on. */
export const LazyCurtain = loadable(() => import(/* webpackChunkName: "content/guest/header/motion/curtain" */ './Curtain'), 'Curtain');
